<ul class="list-inline stack-mobile wc-value-contianer">
  <li>
    <div class="wc-custom-field-dd-inline-block">
      <br /><button pButton type="button" class="atlas-btn atlas-btn-danger mr-2" icon="pi pi-trash" (click)="remove()"></button>
    </div>
    <div class="wc-custom-field-dd-inline-block">
      {{ 'events.settings.registration-fields.value' | translate | titlecase }}
      <br />
      <input
        type="text"
        class="form-control wc-custom-field-dd-option wc-custom-field-dd-option-value"
        [(ngModel)]="availableValue.Value"
        required
        #valueField="ngModel"
        [ngClass]="{ 'ng-invalid': valueField.invalid && (valueField.dirty || valueField.touched) }"
      />
    </div>
  </li>
  <li>
    {{ 'events.settings.registration-fields.description' | translate | titlecase }}
    <br />
    <input
      type="text"
      class="form-control wc-custom-field-dd-option wc-custom-field-dd-option-description"
      [(ngModel)]="availableValue.Descr"
      required
      #descrField="ngModel"
      [ngClass]="{ 'ng-invalid': descrField.invalid && (descrField.dirty || descrField.touched) }"
    />
  </li>
  <li>
    {{ 'events.settings.registration-fields.additional-cost' | translate | titlecase }}
    <br /><input type="number" class="form-control wc-custom-field-dd-option" [(ngModel)]="availableValue.Amount" min="0" />
  </li>
  <li>
    {{ 'events.settings.registration-fields.unit-limit' | translate | titlecase }}
    <br /><input
      type="number"
      class="form-control wc-custom-field-dd-option"
      step="1"
      [(ngModel)]="availableValue.UnitsAvailable"
      min="0"
    />
  </li>
  <li [hidden]="availableValue.UnitsAvailable <= 0">
    {{ 'events.settings.registration-fields.units-remaining' | translate | titlecase }}
    <br />{{ availableValue.UnitsAvailable - availableValue.UnitsTaken }}
  </li>
</ul>
